import { render, staticRenderFns } from "./EvaluationComponent_v2.vue?vue&type=template&id=4fa21d91&"
import script from "./EvaluationComponent_v2.vue?vue&type=script&lang=js&"
export * from "./EvaluationComponent_v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports